/**
 * Every route in the lecture portal is built from these constants so that the
 * URL scheme lives in exactly one place.
 */

export const LEARN_ROOT = "/learn"

export const learnPaths = {
    root: LEARN_ROOT,
    auth: `${LEARN_ROOT}/auth`,
    login: `${LEARN_ROOT}/auth/login`,
    signup: `${LEARN_ROOT}/auth/signup`,
    home: `${LEARN_ROOT}/home`,
    myCourses: `${LEARN_ROOT}/my-courses`,
    course: (course_id) => `${LEARN_ROOT}/course/${course_id}`,
    lecture: (course_id, lecture_id) =>
        `${LEARN_ROOT}/course/${course_id}/lecture/${lecture_id}`
}

/** Header navigation for the portal, rendered by LearnHeader. */
export const learnNavItems = [
    { label: "Home", path: `${LEARN_ROOT}/home` },
    { label: "My Courses", path: `${LEARN_ROOT}/my-courses` }
]

/** Staff-side route for managing lecture content. */
export const MANAGE_LECTURES_ROOT = "/lectures"

export const managePaths = {
    root: MANAGE_LECTURES_ROOT,
    course: (course_id) => `${MANAGE_LECTURES_ROOT}/course/${course_id}`,
    /* The Q&A tab of the course list, filtered to one course */
    questions: (course_id) => `${MANAGE_LECTURES_ROOT}?tab=qa&course=${course_id}`
}
